<template>
  <router-view />
</template>
<script lang="ts">
import { defineComponent, onMounted, provide, ref, watch } from 'vue'
import createMockServer from './mock-server/index'
import './css/tailwind.css'
import { useUserStore } from './store/useUserStore'
import { useI18n } from 'vue-i18n'
import { appTimeStore } from './store/useAppTime'
import { storeToRefs } from 'pinia'
import { useRouter, useRoute } from 'vue-router'
import { useTimesheets } from './store/timesheets'
import { useGlobalTimesheetInstance } from './store/useGlobalTimesheetInstance'
import { Timesheet } from './types/timers'
export const workingDate = ref(new Date())
export default defineComponent({
  name: 'App',
  setup() {
    if (process.env.NODE_ENV === 'development') {
      void createMockServer()
      console.log('API Mock Server started')
    }
    useI18n().locale.value = useUserStore().language

    //Start process of watching current time in app
    const { watchAppTime } = appTimeStore()
    watchAppTime()
    // const workingDate = ref(new Date())
    const setDate = (newDate: Date) => {
      console.log(`setting date ${newDate}`)
      workingDate.value = newDate
    }
    provide('date', workingDate)
    provide('setDate', setDate)

    //timesheet logic
    const globalTimesheetInstance = ref()
    // const globalTimesheetIndex = ref()
    // eslint-disable-next-line
    const setGlobalTimesheetInstance = (timesheet: Timesheet, index: number) => {
      console.log('setting globalTimesheetInstance')
      globalTimesheetInstance.value = timesheet
      globalTimesheetInstance.value.editing = true
      // globalTimesheetIndex.value = index
    }
    provide('globalTimesheetInstance', globalTimesheetInstance)
    provide('setGlobalTimesheetInstance', setGlobalTimesheetInstance)

    const { swapTimecardTimersBack } = useGlobalTimesheetInstance()
    const cancelEdits = async () => {
      if (globalTimesheetInstance.value) {
        globalTimesheetInstance.value.editing = false
        globalTimesheetInstance.value = undefined
        const reset = !(route.name == 'previous_activity')
        await swapTimecardTimersBack({ reset })
        if (setDate) setDate(new Date())
      }
    }
    provide('cancelEdits', cancelEdits)

    const { now } = storeToRefs(appTimeStore())
    const { bundleIncompleteTimecard } = useTimesheets()
    const route = useRoute()
    const router = useRouter()
    // Watch for a change in get day.
    watch(
      () => now.value.getDay(),
      async () => {
        //stop edits for global ts
        if (globalTimesheetInstance.value) {
          await cancelEdits()
        }
        // App passed into new day - If any incomplete activities, bundle them and navigate to edit screen
        await bundleIncompleteTimecard()
        if (hasIncompleteTimecard.value) {
          //redirect so rep can finish
          await redirectToIncomplete()
        } else {
          //advance day as normal
          setDate(now.value)
        }
      }
    )

    const { hasIncompleteTimecard } = storeToRefs(useTimesheets())
    const { getIncompleteIndex } = useTimesheets()
    /**Redirects to the first incomplete timecard if there are incomplete timecards.
     * There really should only be one incomplete. */
    const redirectToIncomplete = async () => {
      const index = getIncompleteIndex()
      console.log('indexredir', index)
      if (index > -1) {
        await router.push({ name: 'previous_activity', params: { id: index } })
      }
    }
    onMounted(async () => {
      const { hasIncompleteTimecard: incompleteOnBoot } = storeToRefs(useTimesheets())
      if (incompleteOnBoot.value) {
        console.log('has incomplete timecard on boot')
        await redirectToIncomplete()
      }
    })

    watch(
      hasIncompleteTimecard,
      async () => {
        if (hasIncompleteTimecard.value) {
          await redirectToIncomplete()
        }
      },
      { flush: 'post' }
    )
  },
})
</script>
